import type React from 'react';
import { useCallback } from 'react';

import { DefaultInput } from '@cobliteam/base-components/src/Input/DefaultInput';

import { SearchRounded } from '@material-ui/icons';

export interface UserSearchProps {
  textFilter: string;
  setTextFilter: (newText: string) => void;
}

const UserSearch = ({ textFilter, setTextFilter }: UserSearchProps) => {
  const handleTextChange = useCallback(
    (value: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setTextFilter(value.target.value);
    },
    [setTextFilter]
  );

  return (
    <DefaultInput
      startAdornment={<SearchRounded />}
      placeholder='Procure por usuários'
      value={textFilter}
      debounceInMillis={500}
      autoFocus
      onChange={handleTextChange}
      fullWidth
    />
  );
};

export default UserSearch;
